document.addEventListener('DOMContentLoaded', () => {
    function fraud_inputs_handler(is_fraud_input) {
        const fraud_inputs_container = document.querySelector('#cms_third_party_claim_intimation_claim_fraud_inputs_container');

        if (is_fraud_input.checked) {
            fraud_inputs_container.classList.remove('hidden');
        } else {
            fraud_inputs_container.classList.add('hidden');
        }
    }

    let tp_claim_intimation_fraud = document.querySelector('#cms_third_party_claim_intimation_claim_fraud');

    if (tp_claim_intimation_fraud !== null) {
        fraud_inputs_handler(tp_claim_intimation_fraud)

        tp_claim_intimation_fraud.addEventListener('click', function () {
            fraud_inputs_handler(this)
        });
    }
});
